export const SLOT_QUERY_PARAM_KEY = 'slot';

export enum Slot {
  ACTION,
  PAY,
  POST_PAY,
  SETTINGS,
  UI,
}

export enum SlotQueryParamValues {
  ACTION = 'action',
  PAY = 'pay',
  POST_PAY = 'postpayment',
  SETTINGS = 'settings',
}
